import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { addCommas } from '../Util';

interface MoneyProps{
	className?: string,
	value: number,
	fixed?: boolean,
	hideZeroes?: boolean,
	grayedZero?: boolean,
	style?: React.CSSProperties
}

var Money = (props: MoneyProps)=>{
	return <span style={props.style} className={classNames(props.className, {
		'ar grayed': props.grayedZero && props.value<=0
	})}>
		<span className="ar money-sign">$</span>
		{addCommas(props.value, props.fixed!==false, !!props.hideZeroes)}
	</span>
}

export default Money;